module.exports = __webpack_public_path__ + "img/nurse1.be72af14.svg";